export const TimeslotEndpoints = {
  GET_ALL_TIMESLOTS: '/api/admin/timeslots',
  UPDATE_TIMESLOT: '/api/admin/timeslots',
};
